import React from "react"
import { TextField } from "@mui/material"

const FormikTextField = ({ field, ...props }) => (
  <TextField {...field} {...props} />
)

export default FormikTextField